import styled from 'styled-components';
import { IDropdownStyles } from '@fluentui/react';

export const CardsRowWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    margin-top: 15px;
    box-sizing: border-box;
`;

export const InternalSwitchCardContainer = styled.div`
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
    background: ${props => props?.theme?.palette?.white};
    border-radius: 16px;
    box-shadow: 0.5px 1px 2px rgba(0, 0, 0, 0.25);
    padding: 20px;
    cursor: default;
`;

export const InternalSwitchCardTitle = styled.h4`
    padding-bottom: 18px;
    color: #cc2250;
`;

export const InternalSwitchCardContent = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
    font-size: 20px;
`;

export const InternalSwitchCardFooter = styled.div`
    color: #cc2250;
`;

export const DocumentsContainer = styled.div`
    margin: 20px 0;
    padding: 20px;
    background: ${props => props?.theme?.palette?.white};
    border-radius: 8px;
    box-shadow: 0.5px 1px 2px rgba(0, 0, 0, 0.25);
`;

export const DocumentsTitle = styled.h3`
    color: #cc2250;
    margin-bottom: 15px;
`;

export const WithDate = styled.div`
    display: flex;
    align-items: center;
    color: #28a745;
    
    & > i
    {
        margin-right: 8px;
    }
`;

export const WithoutDate = styled.div`
    display: flex;
    align-items: center;
    color: #dc3545;
    font-size: 12px;
    
    & > i
    {
        margin-right: 8px;
    }
`;

export const UserLoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    flex-direction: column;
    gap: 16px;
`;

export const UserLoadingDisclaimer = styled.span`
    font-size: 14px;
    color: #666;
`;

export const MessageBarWrapper = styled.div`
    margin: 15px 0;
`;

export const TitleRow = styled.div`
    min-height: 20px;
`;

export const SubTitleCol = styled.div`
    padding-top: 12px;
    color: #CC214F;
`;

export const SectionMargin = styled.div`
    margin-bottom: 15px;
    margin-top: -10px;
    cursor: default;
`;

export const PromotionsListWrapper = styled.div`
    margin: 15px 0;

    & > *:not(:last-child)
    {
        margin-bottom: 10px;
    }
`;

export const PromotionTitle = styled.strong`
    font-size: 16px;
`;

export const SpinnerWithMargin = styled.span`
    margin-right: 10px;
`;

export const PromotionsLoadingRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const SourceFundFieldWrapper = styled.div`
    width: 100%;
    display: inline-block;
`;

export const SourceFundLabel = styled.label`
    width: 100%;
    display: inline-block;
`;

export const LoadingFundsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 120px;
    padding: 20px 0;
`;

export const EstimatedCalculationIntroText = styled.p`
    margin: 0 0 15px 0;
    font-size: 14px;
    color: #605e5c;
    cursor: default;
    line-height: 1.4;
`;

export const CardsFlexWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const CardTitleIconsWrapper = styled.div`
    float: right;
`;

export const SimularButtonWrapper = styled.span`
    margin-right: 1em;
`;

export const DocumentClickErrorBarWrapper = styled.div`
    margin-bottom: 15px;
`;

export const DocumentsIntroText = styled.p`
    margin-bottom: 20px;
    color: #666;
`;

export const CardsDisclaimerWrapper = styled.div`
    margin: 20px 0 0;
    padding: 12px 16px;
    border-radius: 12px;
    background: #FFF1BE;
    cursor: default;
`;

export const CardsDisclaimerText = styled.p`
    margin: 0;
    font-size: 13px;
    color: #F69A2D;
    line-height: 1.4;
    font-weight: 500;
`;

export const InstantCalculationTitle = styled.h3`
    margin: 19px 0 10px 0;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    cursor: default;
`;

export const DocumentsSubtitle = styled.h4`
    color: #cc2250;
    margin-bottom: 10px;
`;

export const LoadingDocsContainer = styled.div`
    text-align: center;
    padding: 20px;
`;

export const LoadingDocsText = styled.p`
    margin-top: 10px;
`;

export const WarningContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    cursor: default;
    border-radius: 16px;
    background: #FFF1BE;
    color: #F69A2D;
    padding: 30px;
    gap: 12px;
    font-weight: 500;
    & > div:first-of-type
    {
        flex-shrink: 0;
    }
    img
    {
        display: block;
    }
    p
    {
        line-height: 20px;
        margin: 0;
    }
`;

export const AmountDisclaimerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    cursor: default;
    border-radius: 16px;
    background: #FFF1BE;
    color: #F69A2D;
    padding: 16px 20px;
    gap: 12px;
    font-weight: 500;
    margin: 10px 0 0;
    p
    {
        line-height: 20px;
        margin: 0;
    }
`;

export const AutoSwitchWarningWrapper = styled.div`
    margin: 10px 0 0;
`;

export const dropdownStyles: Partial<IDropdownStyles> =
{
    caretDown:
    {
        fontSize: "14px !important",
        fontWeight: 400,
        borderColor: "trasparent"
    },
    dropdownItems:
    {
        borderColor: "transparent",
        fontWeight: 400,
        fontSize: "14px !important",
        margin: "0px",
        color: "#556769 !important",
        "& :hover":
        {
            "& :hover span span":
            {
                color: "rgb(204, 33, 79)"
            }
        }
    },
    title:
    {
        color: "#556769 !important",
        borderColor: "#95A0A1 !important",
        fontWeight: 400,
        fontSize: "14px !important",
        marginTop: "5px"
    },
    dropdownItemSelected:
    {
        color: "white",
        margin: "0px",
        backgroundColor: "rgb(204, 33, 79) !important",
        "& span span":
        {
            color: "white !important"
        }
    },
    dropdownOptionText: { color: "#556769" }
};